
import pageNotFoundImage from "~/assets/images/pageNotFoundImage.svg";
import commonAccessDenied from "../components/common/common-access-denied.vue";

export default {
  components: { commonAccessDenied },
  props: {
    error: {
      type: Object,
      default: null
    }
  },
  data() {
    return {
      pageNotFoundImage
    };
  },
  methods: {
    goHome() {
      this.$router.push("/");
    }
  }
};
